const SETTINGS_OPENED_TOGGLE = 'SETTINGS/TOGGLE';

export default function settingsOpenedToggleAction (toggle: boolean) {
  return {
    type: SETTINGS_OPENED_TOGGLE,
    payload: {
        settingsOpened: toggle
    }
  };
}

export { SETTINGS_OPENED_TOGGLE };